import { FileType } from "./FileType";
import { FormType } from "./FormType";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SubType = { ...FileType, ...FormType } as const;
/**
 * Due to destructing to allow automatic merging of typings.
 * Subtype has to be re-exported as a derived value type in order to mimic Enum type and usage.
 */
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SubType = (typeof SubType)[keyof typeof SubType];
